import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from "wix-ui-core/dist/es/src/hocs/Focusable/FocusableHOC";
import styles from './ToggleButton.st.css';
import Text from '../../Text';

var addPrefix = function addPrefix(icon) {
  return icon && /*#__PURE__*/React.cloneElement(icon, {
    width: '24',
    height: '24',
    className: styles.prefix
  });
};

var ToggleButton = function ToggleButton(_ref) {
  var children = _ref.children,
      prefixIcon = _ref.prefixIcon,
      selected = _ref.selected,
      dataHook = _ref.dataHook,
      focusableOnFocus = _ref.focusableOnFocus,
      focusableOnBlur = _ref.focusableOnBlur,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["children", "prefixIcon", "selected", "dataHook", "focusableOnFocus", "focusableOnBlur", "disabled"]);

  return /*#__PURE__*/React.createElement("button", _extends({}, rest, styles('root', {
    selected: selected
  }, rest), {
    "data-hook": dataHook,
    "data-selected": selected,
    disabled: disabled,
    onFocus: focusableOnFocus,
    onBlur: focusableOnBlur,
    type: "button"
  }), addPrefix(prefixIcon), /*#__PURE__*/React.createElement(Text, {
    ellipsis: true,
    size: "medium",
    weight: "normal",
    skin: disabled ? 'disabled' : 'standard'
  }, children));
};

ToggleButton.propTypes = {
  children: PropTypes.node,
  prefixIcon: PropTypes.node,
  value: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool
};
ToggleButton.displayName = 'SegmentedToggle.Button';
export default withFocusable(ToggleButton);